// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1rC0w","description":"PatientConsentPreview_description__2HBOl"};